import React, { useEffect, useRef, useState } from "react"
import { getSrc } from "gatsby-plugin-image"

import useIsIntersecting from "@/hooks/is-intersecting"

const LazyVideo = ({
  video,
  fallback,
  type = "video/mp4",
  className = "",
  alt,
  width,
  height,
  loop = false,
}) => {
  const videoRef = useRef(null)
  const posterUrl =
    typeof fallback === "string" ? fallback : fallback ? getSrc(fallback) : null

  const isIntersecting = useIsIntersecting(videoRef, {
    rootMargin: "0px",
    threshold: [0.6, 1],
  })

  const [hasPlayedVideo, setHasPlayedVideo] = useState(false)

  useEffect(() => {
    const shouldPlayVideo = loop || !hasPlayedVideo

    if (isIntersecting && shouldPlayVideo) {
      videoRef.current.play()
      setHasPlayedVideo(true)
    }
  }, [hasPlayedVideo, isIntersecting, loop])

  return (
    <>
      <video
        className={`lazy-video ${className}`}
        playsInline
        muted
        loop={loop}
        disableRemotePlayback
        ref={videoRef}
        width={width}
        height={height}
        poster={posterUrl || undefined}
      >
        <source src={video} type={type} />
      </video>

      {alt && <p className="screen-reader-only">{alt}</p>}
    </>
  )
}

export default LazyVideo
